var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pa-0"},[_c('CreateProductForm',{attrs:{"goback":_vm.returnTo,"supplier":_vm.supplier}},[_c('SupplierSelectField',{attrs:{"disabled":""},model:{value:(_vm.supplier),callback:function ($$v) {_vm.supplier=$$v},expression:"supplier"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }